(ns quuppa.date-time.core
  "The Way of Date & Times in Quuppa. Cross-platform.

  We use java.time in backend, and js-joda in frontend.

  Usage of java.util.Date and native js Date is discouraged!"
  #?(:cljs (:require ["@js-joda/core" :as js-joda :refer [ZoneId DateTimeFormatter Instant ZonedDateTime]]
                     [komponentit.timeago :as timeago]))
  #?(:clj (:import (java.util Date)
                   (java.time ZoneId Instant ZonedDateTime)
                   (java.time.format DateTimeFormatter))))

(defn instant? [o]
  (instance? Instant o))

(def ^DateTimeFormatter date-format (. DateTimeFormatter -ISO_DATE))
(def ^DateTimeFormatter local-date-format (. DateTimeFormatter -ISO_LOCAL_DATE))
(def ^DateTimeFormatter date-time-format (. DateTimeFormatter ofPattern "yyyy-MM-dd HH:mm:ss ('UTC'xxx)"))
(def ^DateTimeFormatter date-time-format-without-utc (. DateTimeFormatter ofPattern "yyyy-MM-dd HH:mm:ss"))

(defn native-date->instant
  #?(:cljs "JS Date -> js-joda Instant"
     :clj "java.util.Date -> java.time.Instant")
  ^Instant
  [native]
  #?(:clj (.toInstant ^Date native)
     :cljs (.from Instant (js-joda/nativeJs native))))

(defn temporal->native-date
  #?(:cljs "js-joda Instant | LocalDate | LocalDateTime | ZonedDateTime -> JS Date (see js-joda 'convert')"
     :clj "java.time.Instant -> java.util.Date")
  [^Instant value]
  (when value
    #?(:cljs (let [converted (js-joda/convert value)]
               (when converted
                 (.toDate converted)))
       :clj (Date/from value))))

(defn instant->utc
  "'Moves' Instant to UTC timezone, returns ZonedDateTime @ UTC."
  ^ZonedDateTime
  [^Instant instant]
  (.atZone instant (. ZoneId of "UTC")))

(defn zoned-now ^ZonedDateTime []
  #?(:cljs (. js-joda/ZonedDateTime now))
  #?(:clj (ZonedDateTime/now)))

(defn now []
  #?(:cljs (.now Instant))
  #?(:clj (Instant/now)))

;;
;; Format
;;

(defn format-date
  "Format a date, i.e. 2021-10-10.

  Also includes the timezone."
  [v]
  (when v
    (.format date-format v)))

(defn format-local-date
  "Format a date, i.e. 2021-10-10."
  [v]
  (when v
    (.format local-date-format v)))

(defn format-date-time
  "Format date and a time."
  [v]
  (when v
    (if (instance? Instant v)
      (.format date-time-format (instant->utc v))
      (.format date-time-format v))))

(defn format-date-time-without-utc
  "Format date and time without UTC."
  [v]
  (when v
    (if (instance? Instant v)
      (.format date-time-format-without-utc (instant->utc v))
      (.format date-time-format-without-utc v))))

(defn format-instant-without-utc
  "Format Instant, without displaying UTC time."
  [v]
  (when v
    (format-date-time-without-utc (instant->utc v))))

(defn format-instant
  "Format Instant, displaying it as UTC time."
  [v]
  (when v
    (format-date-time (instant->utc v))))


#?(:cljs (def duration-string timeago/default-format-2))

(comment
  (format-date (ZonedDateTime/now ZoneOffset/UTC))
  (format-date (ZonedDateTime/now (ZoneId/of "Europe/Helsinki")))
  (format-local-date (LocalDate/now ZoneOffset/UTC)))
